import { userConstants } from '../constants'
import { userService } from '../services'
import { alertActions } from './alert.actions'
import { history, signalrConfig, BaseURL } from '../helpers'

export const userActions = {
	login,
	loginToken,
	logout,
	register,
	validateToken,
    getYaaUserProfileById,
    GetAcceptDisclamer,
    AcceptDisclamerLog,
}

function login(username, password) {
	return dispatch => {
		dispatch(request({ username }))

		// TODO connect api
		userService.login(username, password).then(
			user => {
				dispatch(success(user))

				history.push(`${BaseURL}/`)
			},
			error => {
				dispatch(failure(error.toString()))
				dispatch(alertActions.error(error.toString()))
			}
		)
	}

	function request(user) {
		return { type: userConstants.LOGIN_REQUEST, user }
	}
	function success(user) {
		return { type: userConstants.LOGIN_SUCCESS, user }
	}
	function failure(error) {
		return { type: userConstants.LOGIN_FAILURE, error }
	}
}

function loginToken(token) {
	return dispatch => {
		dispatch(request({ token }))
		// TODO connect api
		userService.loginToken(token).then(
			user => {
				dispatch(success(user))

				// signalrConfig.startConnection()

				history.push(`${BaseURL}/`)
			},
			error => {
				dispatch(failure(error.toString()))
				dispatch(alertActions.error(error.toString()))
			}
		)
	}

	function request(user) {
		return { type: userConstants.LOGIN_REQUEST, user }
	}
	function success(user) {
		return { type: userConstants.LOGIN_SUCCESS, user }
	}
	function failure(error) {
		return { type: userConstants.LOGIN_FAILURE, error }
	}
}

function logout() {
	// signalrConfig.closeConnection()
	userService.logout()
	return { type: userConstants.LOGOUT }
}

function register(user) {
	return dispatch => {
		dispatch(request(user))

		userService.register(user).then(
			res => {
				dispatch(success())
				history.push(`${BaseURL}/register-status/${res.token}`)
				dispatch(alertActions.success('Registration successful'))
			},
			error => {
				dispatch(failure(error.toString()))
				dispatch(alertActions.error(error.toString()))
			}
		)
	}

	function request(user) {
		return { type: userConstants.REGISTER_REQUEST, user }
	}
	function success(user) {
		return { type: userConstants.REGISTER_SUCCESS, user }
	}
	function failure(error) {
		return { type: userConstants.REGISTER_FAILURE, error }
	}
}

function validateToken(token) {
	return dispatch => {
		userService.validateToken(token).then(
			res => {
				if (!res.validate) {
					history.push(`${BaseURL}/login`)
					dispatch(alertActions.error('Validate Token Fail'))
				}
			},
			error => {
				dispatch(alertActions.error(error.toString()))
			}
		)
	}
}

function getYaaUserProfileById(id) {
	return dispatch => {
		dispatch(request())

		userService.getYaaUserProfileById(id).then(
			user_yaa_profile => {
				setTimeout(() => {
					dispatch(success(user_yaa_profile))
				}, 500)
			},
			error => {
				dispatch(failure(error.toString()))
				dispatch(alertActions.error(error.toString()))
			}
		)
	}

	function request() {
		return { type: userConstants.GET_USER_YAA_BY_ID_REQUEST }
	}
	function success(user_yaa_profile) {
		return { type: userConstants.GET_USER_YAA_BY_ID_SUCCESS, user_yaa_profile }
	}
	function failure(error) {
		return { type: userConstants.GET_USER_YAA_BY_ID_FAILURE, error }
	}
}

function GetAcceptDisclamer(id) {
    return dispatch => {
        dispatch(request())

        userService.GetAcceptDisclamer(id).then(
            isDisclamer => {
                setTimeout(() => {
                    dispatch(success(isDisclamer))
                }, 500)
            },
            error => {
                dispatch(failure(error.toString()))
                dispatch(alertActions.error(error.toString()))
            }
        )
    }

    function request() {
        return { type: userConstants.GET_USER_ACCEPT_REQUEST }
    }
    function success(isDisclamer) {
        return { type: userConstants.GET_USER_ACCEPT_SUCCESS, isDisclamer }
    }
    function failure(error) {
        return { type: userConstants.GET_USER_ACCEPT_FAILURE, error }
    }
}

function AcceptDisclamerLog(id,acceptType) {
    return dispatch => {
        dispatch(request())

        userService.AcceptDisclamerLog(id, acceptType).then(
            isDisclamer => {
                setTimeout(() => {
                    dispatch(success(isDisclamer))
                }, 500)
            },
            error => {
                dispatch(failure(error.toString()))
                dispatch(alertActions.error(error.toString()))
            }
        )
    }

    function request() {
        return { type: userConstants.POST_USER_ACCEPT_REQUEST }
    }
    function success(isDisclamer) {
        return { type: userConstants.POST_USER_ACCEPT_SUCCESS, isDisclamer }
    }
    function failure(error) {
        return { type: userConstants.POST_USER_ACCEPT_FAILURE, error }
    }
}

